import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { Message } from 'src/app/models/message';
import { Publication } from 'src/app/models/obs/publication';
import { PubTematic } from 'src/app/models/obs/pubtematic';
import { Tematic } from 'src/app/models/obs/tematic';
import { PublicationService } from 'src/app/services/obs/publication.service';
import { PubtematicService } from 'src/app/services/obs/pubtematic.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { PublicationComponent } from '../publication.component';

@Component({
  selector: 'app-publication-detail',
  templateUrl: './publication-detail.component.html',
  styleUrl: './publication-detail.component.scss'
})
export class PublicationDetailComponent implements OnInit {

  pub: Publication;
  tematic: Tematic[] = [];
  pubTematics: PubTematic[] = [];
  msg: Message;
  pubComponent: PublicationComponent;

  URL: string = urlEndPoint;

  constructor(
    private publicationService: PublicationService,
    private activedRoute: ActivatedRoute,
    private tematicService: TematicService,
    private pubTematicService: PubtematicService,
    private router: Router) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    if (params['id'] != null) {
      this.getPubs(params['id']);
      this.getPubTematics(params['id']);
      this.getTematics();
      this.subscritorPage();
    }

  }

  getPubs(id: string) {
    this.publicationService.getOne(id).subscribe(
      async res => {
        this.pub = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  getTematics() {
    this.tematicService.getAll().subscribe(
      res => {
        this.tematic = res['data'];
        /*  Reasignar colores de acuerdo a las temáticas de la publicación */
        this.tematic.forEach(t => {
          let band = 0; //contador de coincidencias
          this.pubTematics.forEach(pt => {
            if (t.id !== pt.idtematic) {
              band++;
              if (band == this.pubTematics.length) t.color = '#000000B3';
            }
          });

        });
      },
      err => { this.msg = err; }
    );
  }


  getPubTematics(id: string) {
    this.pubTematicService.getByIdPublication(id).subscribe(
      async res => {
        this.pubTematics = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  subscritorPage() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (evt.url.substring(20, 28) == "tematica") {
        window.scrollTo(0, 680)
      } else {
        window.scrollTo(0, 0)
      }
    });
  }

}
